/* eslint-disable */
import { useState, useMemo, useCallback, useEffect } from 'react';
import {
  saveUserPreferences,
  SORT_SETTING_KEY,
} from '../../../common/services/userPreferencesProjectService';
import { CUSTOM_GROUP_NAME } from '../models/constants';
import { Dropdown } from '../models/Dropdown';
import { setDropdownBySortPreference } from './sortUtilities';

export const optionDetails = {
  contentOrder: { index: 0, apiParameter: 'sortorder', text: 'Content Order' },
  dateUpdated: { index: 1, apiParameter: 'datemodified', text: 'Date updated' },
  groupTitle: { index: 2, apiParameter: 'title', text: 'Group title' },
};

let prevSelectedOptionIndex = optionDetails.contentOrder.index;

const DEFAULT_OPTION_NAME = optionDetails.contentOrder.text;
const ASC_ORDER_ICON = 'sort-arrow-asc';
const DESC_ORDER_ICON = 'sort-arrow-desc';

// @deprecated
const useSortingDropdownCustom = (
  sortingCallback: (tagIds: number[], sortBy: string, page?: number) => void,
  orderAscRef: React.MutableRefObject<boolean>,
  tags: number[],
  projectId: number,
  sortingType: string
): Dropdown => {
  let options = useMemo(
    () => [
      {
        text: 'Content Order',
        icon: orderAscRef.current === true ? ASC_ORDER_ICON : DESC_ORDER_ICON,
        iconClassName: 'outline icon-orange-theme',
        disabled: false,
        onClick: () => {
          onClickHandler(
            optionDetails.contentOrder.index,
            optionDetails.contentOrder.apiParameter
          );
          sortingCallback(tags, optionDetails.contentOrder.apiParameter);
        },
      },
      {
        text: 'Date updated',
        iconClassName: 'outline icon-orange-theme',
        disabled: false,
        onClick: () => {
          onClickHandler(
            optionDetails.dateUpdated.index,
            optionDetails.dateUpdated.apiParameter
          );
          sortingCallback(tags, optionDetails.dateUpdated.apiParameter);
        },
      },
      {
        text: 'Group title',
        iconClassName: 'outline icon-orange-theme',
        disabled: false,
        onClick: () => {
          onClickHandler(
            optionDetails.groupTitle.index,
            optionDetails.groupTitle.apiParameter
          );
          sortingCallback(tags, optionDetails.groupTitle.apiParameter);
        },
      },
    ],
    [tags]
  );

  const [sortingDropdown, setSortingDropdown] = useState<Dropdown>({
    options,
    selectedOption: DEFAULT_OPTION_NAME,
  });

  useEffect(() => {
    // Update the order icon inside the dropdown with updated order icon
    options.forEach((option) => {
      if (option.icon?.trim()) {
        option.icon =
          orderAscRef.current === true ? ASC_ORDER_ICON : DESC_ORDER_ICON;
      }
    });

    const newDropdown: Dropdown = { ...sortingDropdown, options };
    setSortingDropdown(newDropdown);
  }, [orderAscRef.current]);

  useEffect(() => {
    const getPreferences = async () => {
      try {
        const [optionsSort, preferredSortingText] =
          await setDropdownBySortPreference(
            projectId,
            options,
            optionDetails,
            orderAscRef,
            ASC_ORDER_ICON,
            DESC_ORDER_ICON,
            sortingType,
            tags,
            sortingCallback
          );
        if (optionsSort && preferredSortingText) {
          setSortingDropdown({
            options: optionsSort,
            selectedOption: preferredSortingText,
          });
        }
      } catch (e) {
        // In case the API fails the default sorting should be set
        setSortingDropdown({
          ...sortingDropdown,
          selectedOption: DEFAULT_OPTION_NAME,
        });
      }
    };
    if (sortingType === CUSTOM_GROUP_NAME) {
      getPreferences();
    }
  }, []);

  const onClickHandler = useCallback(
    async (selectedIndex: number, apiParameter: string) => {
      // if user clicks on the option that is already selected then change the order
      if (selectedIndex === prevSelectedOptionIndex) {
        orderAscRef.current = !orderAscRef.current;
      } else {
        options[selectedIndex].icon =
          orderAscRef.current === true ? ASC_ORDER_ICON : DESC_ORDER_ICON;
        prevSelectedOptionIndex = selectedIndex;

        options = options.map((option, index) => {
          if (index !== selectedIndex) {
            option.icon = '';
          }
          return option;
        });
      }
      try {
        await saveUserPreferences(
          projectId,
          SORT_SETTING_KEY,
          `${CUSTOM_GROUP_NAME}-${apiParameter}-${
            orderAscRef.current ? 'asc' : 'desc'
          }`
        );
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
      } finally {
        setSortingDropdown({
          options,
          selectedOption: sortingDropdown.options[selectedIndex].text,
        });
      }
    },
    [setSortingDropdown, tags]
  );

  return sortingDropdown;
};

export default useSortingDropdownCustom;
